import { combineReducers } from 'redux';
import { union } from 'lodash';
import { normalize } from '../utils';
import { createSelector } from 'reselect';


// Results state

const resource = (state = [], { type, payload }) => {
  switch (type) {
    case 'IQM_LIST_SUCCESS':
      return [...state, ...payload];
    case 'IQM_RESOURCE_CREATE_SUCCESS':
    case 'IQM_RESOURCE_UPDATE_SUCCESS':
    case 'IQM_RESET_PAGINATION':
      return [];
    default:
      return state;
  }
};

const details = (state = {}, { type, payload }) => {
  switch (type) {
    case 'IQM_RESOURCE_SUCCESS':
    case 'IQM_RESOURCE_CREATE_SUCCESS':
    case 'IQM_RESOURCE_UPDATE_SUCCESS':
      return payload;
    case 'IQM_RESOURCE_REQUEST':
    case 'IQM_RESOURCE_FAILURE':
      return {};
    default:
      return state;
  }
};

// Filters state
const defaultFilters = {
  data: {
    for_workrooms: [],
    is_active: true,
    is_pending: null,
    query: null,
  },
  idsByFilter: [],
};

const filters = (state = defaultFilters, { type, payload }) => {
  switch (type) {
    case 'IQM_LIST_SUCCESS':
      return {
        ...state,
        idsByFilter: union(state.idsByFilter || [], payload.iqms.map(item => item.id)),
      };
    case 'IQM_SET_FILTER':
      return {
        ...state,
        data: Object.assign({}, payload),
      };
    case 'IQM_RESOURCE_CREATE_SUCCESS':
    case 'IQM_RESOURCE_UPDATE_SUCCESS':
    case 'IQM_RESET_PAGINATION':
      return {
        ...state,
        idsByFilter: [],
      };
    case 'IQM_RESET_FILTERS':
      return { ...defaultFilters };
    default:
      return state;
  }
};


const byId = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'IQM_RESOURCE_REQUEST':
    case 'IQM_RESOURCE_SUCCESS':
    case 'IQM_RESOURCE_CREATE_SUCCESS':
    case 'IQM_RESOURCE_UPDATE_SUCCESS': {
      const id = payload.id !== null && payload.id !== undefined ?
                 payload.id : payload.result;
      // If payload has an id, it's a REQUEST action otherwise
      // the id is in the result field from normalizr
      const resourcePayload = payload.entities && payload.entities.iqms
                           && payload.entities.iqms[id];
      return {
        ...state,
        [id]: resource(state[id], { type, payload: resourcePayload }),
      };
    }
    case 'IQM_LIST_SUCCESS':
      return Object.assign({}, state, normalize(payload.iqms));
    default:
      return state;
  }
};


// Common (errors, loading) state

const initialCommon = {
  loading: false,
  loaded: false,
  errors: {},
  has_next_page: true,
  page: 0,
};

const common = (state = initialCommon, { type, payload }) => {
  switch (type) {
    case 'IQM_LIST_REQUEST':
    case 'IQM_RESOURCE_REQUEST':
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case 'IQM_LIST_SUCCESS':
      return {
        ...state,
        loaded: true,
        loading: false,
        page: state.page + 1,
        hasNextPage: payload.has_next_page,
      };
    case 'IQM_RESOURCE_SUCCESS':
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: {},
      };
    case 'IQM_LIST_FAILURE':
    case 'IQM_RESOURCE_FAILURE':
    case 'IQM_RESOURCE_CREATE_FAILURE':
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: payload.errors,
      };
    case 'IQM_RESET_PAGINATION':
      return {
        ...state,
        page: 1,
        hasNextPage: true,
      };
    case 'IQM_RESOURCE_CREATE_SUCCESS':
    case 'IQM_RESOURCE_UPDATE_SUCCESS':
      return {
        ...state,
        errors: {},
        page: 1,
        hasNextPage: true,
      };
    default:
      return state;
  }
};


export default combineReducers({
  byId,
  resource,
  details,
  common,
  filters,
});

const getById = state => state.byId;
const getHasNextPage = state => state.common.hasNextPage;
const getPage = state => state.common.page;
const getLoading = state => state.common.loading;
const getErrors = state => state.common.errors;
const getFiltersData = state => state.filters.data;
const idsByFilter = state => state.filters.idsByFilter;

const getList = createSelector(
  getById,
  idsByFilter,
  (lookup, list) => list.map(id => lookup[id]),
);

export { getList, getHasNextPage, getPage, getLoading, getErrors, getById, getFiltersData };



// WEBPACK FOOTER //
// ./client/app/reducers/iqms.js